import { Navigate, Outlet } from 'react-router-dom';
import { Loading } from '@carbon/react';
import { useAuth } from '@/contexts/AuthContext';

const AdminRoute = () => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="app-page team-admin-loading">
        <Loading withOverlay={false} description="Checking access…" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};

export default AdminRoute;
